import { useMemo } from 'react';

import type { PayoutRequest } from 'api';

const CANCELLABLE_STATUSES = {
  received: [
    'created',
    'capability_selected',
    'validating_external',
    'validated',
    'unable_to_validate_external'
  ],
  pending: ['waiting_future_execution'],
  action_required: ['insufficient_funds'],
  processing: ['halted', 'tstm_initiated', 'added_to_payout_planner']
} as const;

export const useIsPayoutCancellable = (payoutDetails?: PayoutRequest) => {
  const isCancellable = useMemo(() => {
    if (payoutDetails === undefined) {
      return false;
    }

    const status = CANCELLABLE_STATUSES[payoutDetails.status];

    if (status === undefined) {
      return false;
    }

    return status.includes(payoutDetails.current_state_name);
  }, [payoutDetails]);

  return isCancellable;
};
